var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9336 19.999L21.001 19.999",
    stroke: "#787878",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.49925C15.8978 3.10143 16.4374 2.87793 17 2.87793C17.2786 2.87793 17.5544 2.9328 17.8118 3.03941C18.0692 3.14601 18.303 3.30227 18.5 3.49925C18.697 3.69623 18.8532 3.93009 18.9598 4.18746C19.0665 4.44483 19.1213 4.72067 19.1213 4.99925C19.1213 5.27783 19.0665 5.55367 18.9598 5.81104C18.8532 6.06841 18.697 6.30227 18.5 6.49925L6 18.9993L2 19.9993L3 15.9993L15.5 3.49925Z",
    stroke: "#787878",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon2);
export default __webpack_public_path__ + "static/media/edit icon2.8c6a30590936979c6ccb64e247fcc4cf.svg";
export { ForwardRef as ReactComponent };